"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _filters = require("@/filters");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var recharge = [{
  rechargeAmount: '4500',
  giftAmount: '200'
}, {
  rechargeAmount: '4500',
  giftAmount: '200'
}, {
  rechargeAmount: '4500',
  giftAmount: '200'
}, {
  rechargeAmount: '4500',
  giftAmount: '200'
}];
var _default = exports.default = {
  name: 'member_recharge',
  cname: '购物金充值',
  icon: 't-icon-huiyuan-gouwujin',
  configName: 'c_member_recharge',
  type: 2,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'memberRecharge',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain', 'mobileTheme'])), {}, {
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        background: "linear-gradient(to right,".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")")
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    //内容边距
    contentConfig: function contentConfig() {
      return this.configObj.contentConfig.val ? this.configObj.contentConfig.val + 'px' : '0';
    },
    scopeColor: function scopeColor() {
      return [{
        color: this.configObj.scopeColor.color[0].item
      }];
    },
    rechargeBgColor: function rechargeBgColor() {
      return this.configObj.rechargeBgColor.color[0].item;
    },
    //优惠金额颜色
    giveAwayColor: function giveAwayColor() {
      return this.configObj.giveAwayColor.color[0].item;
    },
    amountColor: function amountColor() {
      return this.configObj.amountColor.color[0].item;
    },
    btnInfoColor: function btnInfoColor() {
      return [{
        color: this.themeStyle ? this.configObj.btnInfoColor.color[0].item : '#fff'
      }];
    },
    // 优惠券
    couponListStyle: function couponListStyle() {
      return [{
        marginBottom: this.configObj.contentConfig.val + 'px'
      }, {
        backgroundColor: this.themeStyle ? this.configObj.couponBgColor.color[0].item : this.themeRgba
      },
      // 默认淡橙色背景
      {
        borderRadius: this.configObj.contentStyle.val + 'px'
      }];
    },
    //领取按钮
    btnColorStyle: function btnColorStyle() {
      return [{
        background: this.themeStyle ? "linear-gradient(90deg,".concat(this.configObj.btnColor.color[0].item, ", ").concat(this.configObj.btnColor.color[1].item, ")") : "linear-gradient(".concat(this.linearGradient, ")"),
        color: this.themeStyle ? this.configObj.btnBgColor.color[0].item : '#fff'
      }];
    },
    // 单个卡片样式
    itemStyle: function itemStyle() {
      var margin = this.configObj.contentConfig.val;
      var col = this.colNum;
      // 计算宽度: (100% - (列数-1) * 间距) / 列数
      // 注意：这里需要返回字符串形式的 calc
      return {
        borderRadius: this.configObj.contentStyle.val + 'px',
        width: "calc((100% - ".concat((col - 1) * margin, "px) / ").concat(col, ")")
      };
    },
    // 列数
    colNum: function colNum() {
      if (this.listStyle == 0) return 2;
      if (this.listStyle == 1) return 3;
      if (this.listStyle == 2) return 4;
      return 2;
    },
    // 卡片宽度百分比
    itemWidth: function itemWidth() {
      // (100 - (列数-1) * 间距) / 列数
      // 这里简化处理，直接用 calc 在 style 中动态计算可能更精确，或者用 flex
      // 简单起见，这里返回近似值，实际宽度在 CSS 中控制更好
      // 但因为有 marginRight，需要精确计算
      // 100% / colNum - margin * (colNum - 1) / colNum
      // 为了简单，我们用 flex 布局控制
      return 100; // 这里的返回值会在 style 中被覆盖，或者我们可以直接不返回宽度，用 flex
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        this.configObj.rechargeBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.amountColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.btnInfoColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.btnBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.btnColor.isShow = this.configObj.themeStyleConfig.tabVal;
      },
      deep: true
    },
    rechargeData: function rechargeData(nVal, oVal) {
      if (nVal.length) {
        return this.rechargeList = nVal;
      } else {
        return this.rechargeList = [].concat(recharge);
      }
    }
  },
  data: function data() {
    return {
      rechargeList: [].concat(recharge),
      defaultConfig: {
        name: 'memberRecharge',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '购物金'
        },
        tabConfig: {
          title: '单行数量',
          tabTitle: '布局设置',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '2个'
          }, {
            val: '3个'
          }, {
            val: '4个'
          }]
        },
        titleConfig: {
          title: '标题',
          tabTitle: '购物金设置',
          place: '请输入标题',
          isShow: 1,
          max: 10,
          val: '购物金'
        },
        infoConfig: {
          title: '副标题',
          place: '请输入副标题',
          isShow: 1,
          max: 30,
          val: '5万+用户已充值，人均省16.89元'
        },
        btnInfoConfig: {
          title: '按钮副标题',
          place: '请输入按钮副标题',
          isShow: 1,
          max: 30,
          val: '购物金可随时退'
        },
        rechargeConfig: {
          title: '选择套餐',
          btnTitle: '添加套餐',
          list: [],
          ids: '',
          type: 'recharge'
        },
        titleColor: {
          isShow: 1,
          title: '标题颜色',
          tabTitle: '头部设置',
          color: [{
            item: '#333'
          }],
          default: [{
            item: '#333'
          }]
        },
        infoColor: {
          isShow: 1,
          title: '副标题颜色',
          color: [{
            item: '#333'
          }],
          default: [{
            item: '#333'
          }]
        },
        moreColor: {
          isShow: 1,
          title: '更多颜色',
          color: [{
            item: '#999'
          }],
          default: [{
            item: '#999'
          }]
        },
        giveAwayColor: {
          title: '赠送金额',
          tabTitle: '购物金设置',
          isShow: 1,
          color: [{
            item: '#333333'
          }],
          default: [{
            item: '#333333'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        rechargeBgColor: {
          isShow: 0,
          title: '充值背景',
          color: [{
            item: 'rgba(233, 51, 35, 0.05)'
          }],
          default: [{
            item: 'rgba(233, 51, 35, 0.05)'
          }]
        },
        amountColor: {
          isShow: 0,
          title: '充值金额',
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        btnColor: {
          isShow: 0,
          title: '按钮背景',
          color: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }],
          default: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }]
        },
        btnBgColor: {
          title: '按钮文字',
          isShow: 0,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        btnInfoColor: {
          title: '按钮提示',
          isShow: 0,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        // 背景颜色
        bgColor: {
          tabTitle: '卡片设置',
          title: '组件背景',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        contentConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 10,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'contentStyle',
          val: 7,
          min: 0,
          max: 10
        }
      },
      configObj: null,
      listStyle: 0,
      themeStyle: 0,
      themeColor: '',
      linearGradient: '',
      themeRgba: '',
      rechargeData: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.listStyle = this.configObj.tabConfig.tabVal;
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1); //主题色
        this.linearGradient = this.$options.filters.filterLinearGradient(this.mobileTheme - 1); //渐变色
        this.themeRgba = this.$options.filters.filterThemeRgba(this.mobileTheme - 1); //主题色淡色
        this.rechargeData = this.configObj.rechargeConfig.list;
      }
    }
  }
};